// extracted by mini-css-extract-plugin
export default {"paymentModeTitle":"PaymentCapabilities_paymentModeTitle__VxMSC","toggleTitle":"PaymentCapabilities_toggleTitle__WO3cc","actionContainer":"PaymentCapabilities_actionContainer__Ewpli"};